import React, {useEffect, useState} from "react";
import App from "App";
import {Login} from "views";
import {useTheme} from "hooks";
import store from "redux/store";
import {Provider} from "react-redux";
import {setUser} from "redux/actions";
import {Slide} from "@material-ui/core";
import {SnackbarProvider} from "notistack";
import {BrowserRouter} from "react-router-dom";
import {ThemeProvider} from "@material-ui/styles";
import {Theme as theme, BufferBar} from "components";
import { ReactQueryDevtools } from 'react-query/devtools'
import {QueryClient, QueryClientProvider} from "react-query";

import 'styles/main.css'

export default function Root() {
    const {primary, secondary} = useTheme();
    const [user, updateUser] = useState(null);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        if (localStorage.hasOwnProperty('member')) {
            const member = JSON.parse(localStorage.getItem('member'));
            updateUser(member);
            store.dispatch(setUser(member));
            setLoader(false);
        }else {
            setLoader(false);
        }
    }, []);


    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false
            }
        }
    });

    return (
        <Provider store={store}>
            <ThemeProvider theme={theme(primary, secondary)}>
                <SnackbarProvider maxSnack={3}
                                  anchorOrigin={{vertical: "top", horizontal: "right"}}
                                  autoHideDuration={1000}
                                  TransitionComponent={Slide}>
                    <BrowserRouter basename="message_center">
                        <QueryClientProvider client={queryClient}>
                            {loader ? <BufferBar/> : user ? <App/> : <Login dispatch={store.dispatch} updateUser={updateUser}/> }
                            <ReactQueryDevtools initialIsOpen={false} />
                        </QueryClientProvider>
                    </BrowserRouter>
                </SnackbarProvider>
            </ThemeProvider>
        </Provider>
    )
};
